import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_URL = `${configs.BACKEND_URL}/api`;

async function handleResponse(response) {
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed with status ${response.status}`);
  }
  return response.json();
}

export async function fetchUsers({ pageNumber, pageSize, search, role, name, email, isActive, createdAtStart, createdAtEnd }) {
  const params = new URLSearchParams();
  if (pageNumber) params.set('pageNumber', pageNumber);
  if (pageSize) params.set('pageSize', pageSize);
  if (search) params.set('search', search);
  if (role) params.set('role', role);
  if (name) params.set('name', name);
  if (email) params.set('email', email);
  if (isActive !== undefined && isActive !== null && isActive !== '') params.set('isActive', isActive);
  if (createdAtStart) params.set('createdAtStart', createdAtStart);
  if (createdAtEnd) params.set('createdAtEnd', createdAtEnd);
  const response = await fetchWithTenant(`${API_URL}/user?${params.toString()}`);
  return handleResponse(response);
}

export async function createUser(userData) {
  const response = await fetchWithTenant(`${API_URL}/user`, {
    method: 'POST',
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
}

export async function updateUser(userId, userData) {
  const response = await fetchWithTenant(`${API_URL}/user/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
}

export async function deleteUser(userId) {
  const response = await fetchWithTenant(`${API_URL}/user/${userId}`, {
    method: 'DELETE',
  });
  return handleResponse(response);
}

export async function toggleUserStatus(userId, isActive) {
  const response = await fetchWithTenant(`${API_URL}/user/${userId}/status`, {
    method: 'PUT',
    body: JSON.stringify({ isActive }),
  });
  return handleResponse(response);
}

export async function sendInvitation(inviteData) {
  const response = await fetchWithTenant(`${API_URL}/user/invite`, {
    method: 'POST',
    body: JSON.stringify(inviteData),
  });
  return handleResponse(response);
}

export async function getInvitations() {
  const response = await fetchWithTenant(`${API_URL}/user/invitations`);
  return handleResponse(response);
}

export async function listRoles() {
  const response = await fetchWithTenant(`${API_URL}/role`);
  return handleResponse(response);
}

export async function createRoleApi(roleData) {
  const response = await fetchWithTenant(`${API_URL}/role`, {
    method: 'POST',
    body: JSON.stringify(roleData),
  });
  return handleResponse(response);
}

export async function updateRole(roleId, roleData) {
  const response = await fetchWithTenant(`${API_URL}/role/${roleId}`, {
    method: 'PUT',
    body: JSON.stringify(roleData),
  });
  return handleResponse(response);
}

export async function deleteRole(roleId) {
  const response = await fetchWithTenant(`${API_URL}/role/${roleId}`, {
    method: 'DELETE',
  });
  return handleResponse(response);
}
